import React from 'react';

/**
 * Component to render text with clickable links.
 * Detects URLs and converts them to anchor tags.
 */
const AutoLinkText = ({ text }) => {
    if (!text) return null;

    // Regex to detect URLs
    const urlRegex = /(https?:\/\/[^\s]+)/g;

    const parts = text.split(urlRegex);

    return (
        <span>
            {parts.map((part, index) => {
                if (part.match(urlRegex)) {
                    return (
                        <a
                            key={index}
                            href={part}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="underline hover:text-blue-100 break-all"
                            onClick={(e) => e.stopPropagation()} // Prevent bubble up
                        >
                            {part}
                        </a>
                    );
                }
                return part;
            })}
        </span>
    );
};

export default AutoLinkText;
